import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { IconError } from "../../assets/IconError";
const Styles = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  .text-field {
    z-index: 3;
    width: calc(100%);
    padding: calc(var(--fs-textfield) * 2.3) calc(var(--fs-textfield) * 1.5) calc(var(--fs-textfield) * 0.7);
    border-radius: calc(var(--border-radius) / 2);
    border: 1px var(--border-2) solid;
    outline: none;
    transition: var(--trans-1);
    font-size: var(--fs-textfield);
    background: transparent;
    &.error-text {
      border: 1px var(--secondry-1) solid;
    }
    &.ltr-text {
      direction: ltr;
      text-align: left;
    }
    :focus {
      border: 1px var(--border-3) solid;
    }
  }
  .label-textinput{
    z-index: 2;
    position: absolute;
    top: calc(var(--fs-textfield) * 1.5);
    left: calc(var(--fs-textfield) * 1.5);
    transition: var(--trans-1);
    &.active{
      z-index: 5;
      top: calc(var(--fs-textfield) * 0.5);
      font-size: calc(var(--fs-textfield) * 0.8);
    }
  }
  
  .error {
    display: flex;
    height: 0.75rem;
    font-size: var(--fs-small);
    .icon {
      width: 1rem;
      height: 1rem;
    }
    .text {
      margin: 0.1rem 0.2rem 0 0;
      color: red;
    }
  }
  @media screen and (max-width: 1445px) {
    .text-field {
      padding: calc(var(--fs-textfield) * 1.6) calc(var(--fs-textfield) * 0.75) calc(var(--fs-textfield) * 0.5);
    }
    .label-textinput{
      top: calc(var(--fs-textfield) * 1.05);
      left: calc(var(--fs-textfield) * 1.05);
      &.active{
        top: calc(var(--fs-textfield) * 0.3);
        font-size: calc(var(--fs-textfield) * 0.8);
      }
    }
  }
`;

// dokme chesm baray ramz ha

export const SelectInputWTitle = ({
  style,
  name,
  title,
  error,
  options,
  first,
  value,
  onchange,
  placeHolder,
  required,
  ltr,
}) => {
  const [focused , setFocused] = useState(false);
  useEffect(() => {
    if(value === ''){
      setFocused(false);
    } else {
      setFocused(true);
    }
  }, [value]);

  let errorComp = "";
  let classes = "text-field";
  if (error.toString()) {
    classes = "text-field error-text";
    errorComp = (
      <div className="error">
        <IconError />
        <div className="text">{error}</div>
      </div>
    );
  }
  if (ltr) {
    classes += " ltr-text";
  }
  const makeOption = () => {
    let optionsView = [];
    if (first) {
      optionsView.push(<option key={-1} value={""} disabled>{(typeof first === 'boolean') ? '' : first}</option>);
    }
    if (options) {
      options.forEach((element, index) => {
        optionsView.push(<option key={index} value={element.value}>{element.name}</option>);
      });
    }
    return optionsView;
  };
  return (
    <Styles style={style}>
      <select
        className={classes}
        name={name}
        type="text"
        value={value}
        placeholder={placeHolder}
        onChange={onchange}
        required={required}
        onFocus={(e) => setFocused(true)}
        onBlur={(e) => ((value === '') ? setFocused(false) : '')}
      >
        {makeOption()}
      </select>
      <label className={"label-textinput " + ((focused) ? 'active' : '')}>
        {title}
      </label>
      {errorComp}
    </Styles>
  );
};
